const fbKeys = {
  // apiKey: "AIzaSyByETasiITMQ9ZRv4TxC5Oot9oe3bcXsMk",
  // authDomain: "sensitize-56568.firebaseapp.com",
  // databaseURL: "https://sensitize-56568.firebaseio.com",
  // projectId: "sensitize-56568",
  // storageBucket: "sensitize-56568.appspot.com",
  // messagingSenderId: "662919213348",
  // appId: "1:662919213348:web:d3733ecfe14fc2721dc3b1",
  // measurementId: "G-JQLL4GNG72"
  apiKey: "AIzaSyAlXIShxAyHmMjOxvn3LkldPft8bKrcaW4",
  authDomain: "sensitize-b76e6.firebaseapp.com",
  databaseURL: "https://sensitize-b76e6.firebaseio.com",
  projectId: "sensitize-b76e6",
  storageBucket: "sensitize-b76e6.appspot.com",
  messagingSenderId: "660663013357",
  appId: "1:660663013357:web:feee26394d84e42ef921e4"
};

export default fbKeys;
